<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      勤怠変更申請
    </Header>
    <ApplicationCard
      v-if="application"
      :application="application"
      class="my-3 mx-3"
    />

    <div class="bg-white border border-outline-color p-3 round-4 mx-3">
      <div class="d-flex justify-content-between">
        <p class="text-mild text-size-14">打刻時間</p>
        <p class="text-mild text-size-14">
          {{ workTime }}
        </p>
      </div>
    </div>

    <CustomValidationObserver
      ref="vObserver"
      v-slot="{ handleSubmit }"
      :initialValues="formValues"
    >
      <div class="p-3">
        <div class="pb-3">
          <h2 class="mt-1 text-weight-500">勤務時間</h2>
          <p class="text-size-14 text-mild mt-1">
            実際の勤務時間と休憩時間を入力してください。
          </p>
        </div>
        <label class="mr-1 text-size-14 text-mild">勤務時間</label>
        <AppLabel variant="red">必須</AppLabel>
        <BRow class="mx-n2">
          <BCol class="px-2">
            <div class="d-flex align-items-center">
              <ValidationProvider
                v-slot="validationState"
                name="勤務開始時間(時)"
                rules="required"
                vid="startTime.hour"
              >
                <TimeInput
                  v-model="inputValues.startTime.hour"
                  :validation-state="validationState"
                  :max="23"
                  @blur="
                    onBlurTime(
                      $event,
                      'startTime',
                      'hour',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
              <div class="mx-2">:</div>
              <ValidationProvider
                v-slot="validationState"
                name="勤務開始時間(分)"
                rules="required"
                vid="startTime.minutes"
              >
                <TimeInput
                  v-model="inputValues.startTime.minutes"
                  :validation-state="validationState"
                  :max="59"
                  @blur="
                    onBlurTime(
                      $event,
                      'startTime',
                      'minutes',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
            </div>
          </BCol>
          <BCol cols="auto" class="px-2">
            <p class="mb-3 mt-2 text-center">から</p>
          </BCol>
          <BCol class="px-2">
            <div class="d-flex align-items-center">
              <ValidationProvider
                v-slot="validationState"
                name="勤務終了時間(時)"
                rules="required"
                vid="endTime.hour"
              >
                <TimeInput
                  v-model="inputValues.endTime.hour"
                  :validation-state="validationState"
                  :max="23"
                  @blur="
                    onBlurTime(
                      $event,
                      'endTime',
                      'hour',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
              <div class="mx-2">:</div>
              <ValidationProvider
                v-slot="validationState"
                name="勤務終了時間(分)"
                rules="required"
                vid="endTime.minutes"
              >
                <TimeInput
                  v-model="inputValues.endTime.minutes"
                  :validation-state="validationState"
                  :max="59"
                  @blur="
                    onBlurTime(
                      $event,
                      'endTime',
                      'minutes',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
            </div>
          </BCol>
        </BRow>

        <BForm>
          <ValidationProvider
            v-slot="validationState"
            name="休憩時間"
            vid="hasRestValue"
          >
            <FormRadioGroup
              label="休憩時間"
              appLabelText="必須"
              name="休憩時間"
              v-model="hasRestValue"
              :options="restOptions"
              class="mb-3"
              :validation-state="validationState"
            />
          </ValidationProvider>
        </BForm>
        <BRow v-if="hasRest" class="mx-n2">
          <BCol class="px-2">
            <div class="d-flex align-items-center">
              <ValidationProvider
                v-slot="validationState"
                name="休憩開始時間(時)"
                rules="required"
                vid="restStartTime.hour"
              >
                <TimeInput
                  v-model="inputValues.restStartTime.hour"
                  :validation-state="validationState"
                  :max="23"
                  @blur="
                    onBlurTime(
                      $event,
                      'restStartTime',
                      'hour',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
              <div class="mx-2">:</div>
              <ValidationProvider
                v-slot="validationState"
                name="休憩開始時間(分)"
                rules="required"
                vid="restStartTime.minutes"
              >
                <TimeInput
                  v-model="inputValues.restStartTime.minutes"
                  :validation-state="validationState"
                  :max="59"
                  @blur="
                    onBlurTime(
                      $event,
                      'restStartTime',
                      'minutes',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
            </div>
          </BCol>
          <BCol cols="auto" class="px-2">
            <p class="mb-3 mt-2 text-center">から</p>
          </BCol>
          <BCol class="px-2">
            <div class="d-flex align-items-center">
              <ValidationProvider
                v-slot="validationState"
                name="休憩終了時間(時)"
                rules="required"
                vid="restEndTime.hour"
              >
                <TimeInput
                  v-model="inputValues.restEndTime.hour"
                  :validation-state="validationState"
                  :max="23"
                  @blur="
                    onBlurTime(
                      $event,
                      'restEndTime',
                      'hour',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
              <div class="mx-2">:</div>
              <ValidationProvider
                v-slot="validationState"
                name="休憩終了時間(分)"
                rules="required"
                vid="restEndTime.minutes"
              >
                <TimeInput
                  v-model="inputValues.restEndTime.minutes"
                  :validation-state="validationState"
                  :max="59"
                  @blur="
                    onBlurTime(
                      $event,
                      'restEndTime',
                      'minutes',
                      validationState.handleChange
                    )
                  "
                  type="text"
                  inputmode="numeric"
                />
              </ValidationProvider>
            </div>
          </BCol>
        </BRow>
      </div>

      <div class="p-3">
        <AppButton
          variant="secondary"
          :block="true"
          @click="handleSubmit(onClickSubmitButton)"
          >差額を確認する</AppButton
        >
      </div>
    </CustomValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import Header from "@/components/organisms/common/Header.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import ApplicationCard from "@/components/organisms/applications/ApplicationCard.vue";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import TimeInput from "@/components/molecules/form/TimeInput.vue";
import { applicationService } from "@/app/services/ApplicationService";
import { orderService } from "@/app/services/OrderService";
import CustomValidationObserver from "@/plugins/CustomValidationObserver.vue";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { Application } from "@/types/order/Application";
import { ValidationStateType } from "@/types/Validation";
import {
  addDays,
  addMinutes,
  formatFromISOString,
  formatFromUnixTimestamp,
  parseISO
} from "@/utils/date";
import { attendanceCorrectionStore } from "@/store/attendance-correction";
import { AttendanceCorrectionSalary } from "@/types/application/AttendanceCorrectionSalary";

@Component({
  components: {
    Header,
    AppButton,
    FeatherIcon,
    ApplicationCard,
    FormRadioGroup,
    AppLabel,
    TimeInput
  }
})
export default class AttendanceCorrection extends Vue {
  application: Application | null = null;
  inputValues = {
    startTime: {
      hour: "00",
      minutes: "00"
    },
    endTime: {
      hour: "00",
      minutes: "00"
    },
    restStartTime: {
      hour: "00",
      minutes: "00"
    },
    restEndTime: {
      hour: "00",
      minutes: "00"
    }
  };

  hasRestValue = "";

  restOptions = [
    { value: "1", text: "休憩時間あり" },
    { value: "", text: "休憩時間なし" }
  ];

  get formValues() {
    return {
      startTime: this.inputValues.startTime,
      endTime: this.inputValues.endTime,
      restStartTime: this.inputValues.restStartTime,
      restEndTime: this.inputValues.restEndTime,
      hasRestValue: this.hasRestValue
    };
  }

  get hasRest() {
    return !!this.hasRestValue;
  }

  set hasRest(v: boolean) {
    this.hasRestValue = v ? "1" : "";
  }

  get applicationId() {
    return Number(this.$route.params.applicationId);
  }

  get actualStartWorkAt() {
    return parseISO(
      `${this.application!.order.date}T${this.inputValues.startTime.hour}:${
        this.inputValues.startTime.minutes
      }:00.000000+0900`
    );
  }

  get actualFinishWorkAt() {
    // workStartAt より前なら日付を1日プラス
    const date = parseISO(
      `${this.application!.order.date}T${this.inputValues.endTime.hour}:${
        this.inputValues.endTime.minutes
      }:00.000000+0900`
    );
    return this.correctDate(date);
  }

  get actualStartRestAt() {
    if (!this.hasRest) {
      return null;
    }

    // workStartAt より前なら日付を1日プラス
    const date = parseISO(
      `${this.application!.order.date}T${this.inputValues.restStartTime.hour}:${
        this.inputValues.restStartTime.minutes
      }:00.000000+0900`
    );
    return this.correctDate(date);
  }

  get actualFinishRestAt() {
    if (!this.hasRest) {
      return null;
    }

    // workStartAt より前なら日付を1日プラス
    const date = parseISO(
      `${this.application!.order.date}T${this.inputValues.restEndTime.hour}:${
        this.inputValues.restEndTime.minutes
      }:00.000000+0900`
    );
    return this.correctDate(date);
  }

  get workTime() {
    if (!this.application?.startedWorkAt) {
      return "記録なし";
    }
    const startedWorkAt = formatFromISOString(
      this.application.startedWorkAt,
      "HH:mm"
    );
    let finishedWorkAt = "記録なし";
    if (this.application?.finishedWorkAt) {
      finishedWorkAt = formatFromISOString(
        this.application!.finishedWorkAt!,
        "HH:mm"
      );
    }
    return `${startedWorkAt} - ${finishedWorkAt}`;
  }

  async created() {
    this.$loading.show();
    try {
      await this.fetchApplication();
      const storedSalary = attendanceCorrectionStore.getSalary(
        this.applicationId
      );

      if (
        storedSalary &&
        storedSalary.actualStartWorkAt && // storeに古い形式のsalaryが残っているケースがあるためチェックを追加
        storedSalary.actualFinishWorkAt
      ) {
        this.initWorkTimeByAttendanceCorrectionStore(storedSalary);
      } else {
        this.initWorkTimeByApplication();
      }
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  mounted() {
    // 取得した値でフォームをリセットしておく
    // https://github.com/logaretm/vee-validate/issues/4602
    (this.$refs.vObserver as InstanceType<
      typeof CustomValidationObserver
    >).resetForm(this.formValues);
  }

  async fetchApplication() {
    this.application = await applicationService.fetchApplication(
      this.applicationId
    );
  }

  initWorkTimeByApplication() {
    const application = this.application!;
    const startTime = formatFromISOString(
      application.appliedStartWorkAt,
      "HH:mm"
    );
    const endTime = formatFromISOString(
      application.appliedFinishWorkAt,
      "HH:mm"
    );
    const [startHour, startMinutes] = startTime.split(":");
    const [endHour, endMinutes] = endTime.split(":");
    this.inputValues.startTime = {
      hour: startHour,
      minutes: startMinutes
    };
    this.inputValues.endTime = {
      hour: endHour,
      minutes: endMinutes
    };
    // 休憩開始時間がある場合に休憩終了時間を算出
    if (application.appliedStartRestAt && application.appliedFinishRestAt) {
      const restStartTime = formatFromISOString(
        application.appliedStartRestAt,
        "HH:mm"
      );
      const restEndTime = formatFromISOString(
        application.appliedFinishRestAt,
        "HH:mm"
      );
      const [restStartHour, restStartMinutes] = restStartTime.split(":");
      const [restEndHour, restEndMinutes] = restEndTime.split(":");
      this.inputValues.restStartTime = {
        hour: restStartHour,
        minutes: restStartMinutes
      };
      this.inputValues.restEndTime = {
        hour: restEndHour,
        minutes: restEndMinutes
      };
      this.hasRest = true;
    }
  }

  initWorkTimeByAttendanceCorrectionStore(salary: AttendanceCorrectionSalary) {
    attendanceCorrectionStore.getSalary(this.applicationId)!;
    const startTime = formatFromISOString(salary.actualStartWorkAt!, "HH:mm");
    const endTime = formatFromISOString(salary.actualFinishWorkAt!, "HH:mm");
    const [startHour, startMinutes] = startTime.split(":");
    const [endHour, endMinutes] = endTime.split(":");
    this.inputValues.startTime = {
      hour: startHour,
      minutes: startMinutes
    };
    this.inputValues.endTime = {
      hour: endHour,
      minutes: endMinutes
    };
    if (salary.actualStartRestAt && salary.actualFinishRestAt) {
      const restStartTime = formatFromISOString(
        salary.actualStartRestAt,
        "HH:mm"
      );
      const restEndTime = formatFromISOString(
        salary.actualFinishRestAt,
        "HH:mm"
      );
      const [restStartHour, restStartMinutes] = restStartTime.split(":");
      const [restEndHour, restEndMinutes] = restEndTime.split(":");
      this.inputValues.restStartTime = {
        hour: restStartHour,
        minutes: restStartMinutes
      };
      this.inputValues.restEndTime = {
        hour: restEndHour,
        minutes: restEndMinutes
      };
      this.hasRest = true;
    }
    attendanceCorrectionStore.clearSalary(this.applicationId);
  }

  onClickBack() {
    this.$router.back();
  }

  async onClickSubmitButton() {
    this.$loading.show();

    try {
      const application = this.application!;
      const plannedStartWorkAt = parseISO(application.appliedStartWorkAt);
      const plannedFinishWorkAt = parseISO(application.appliedFinishWorkAt);
      const plannedStartRestAt = application.appliedStartRestAt
        ? parseISO(application.appliedStartRestAt)
        : null;
      const plannedFinishRestAt = application.appliedFinishRestAt
        ? parseISO(application.appliedFinishRestAt)
        : null;

      const salary = await orderService.calcSalary(
        application.hourlyWage,
        application.variousAllowances,
        plannedStartWorkAt,
        plannedFinishWorkAt,
        plannedStartRestAt,
        plannedFinishRestAt,
        this.actualStartWorkAt,
        this.actualFinishWorkAt,
        this.actualStartRestAt,
        this.actualFinishRestAt
      );
      attendanceCorrectionStore.setSalary({
        applicationId: this.applicationId,
        ...salary
      });
      await this.$router.push({
        name: "AttendanceCorrectionConfirmation",
        params: { applicationId: String(this.applicationId) }
      });
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  calcRestEndTime(startTime: string, minutes: number) {
    const restStartTime = parseISO(`2020-01-01 ${startTime}`);
    const restEndTime = addMinutes(restStartTime, minutes);
    return formatFromUnixTimestamp(restEndTime, "HH:mm:ss");
  }

  checkAfterStartTime(date: number) {
    if (!date) return false;
    return this.actualStartWorkAt < date;
  }

  correctDate(date: number) {
    const isAfterStart = this.checkAfterStartTime(date);
    return isAfterStart ? date : addDays(date, 1);
  }

  onBlurTime(
    value: string,
    fieldName: "startTime" | "endTime" | "restStartTime" | "restEndTime",
    type: "hour" | "minutes",
    handleChange: ValidationStateType["handleChange"]
  ) {
    this.inputValues[fieldName][type] = value;
    handleChange(this.inputValues[fieldName][type], false);
  }
}
</script>

<style lang="scss" scoped>
.time-field {
  letter-spacing: 1px;

  &.form-control.is-invalid,
  &.form-control.is-valid {
    padding-right: 8px;
    background-image: none;

    &:focus {
      border-color: $gray-04;
      box-shadow: none;
    }
  }

  &.form-control.is-invalid {
    border-color: $red;
  }
}
</style>
